import React, { useMemo } from 'react'
import Icon from '../babu/Icon'

export default function ItemQuantitySelect(props: {
  maxQuantity: number
  quantity: number
  setQuantity: (q: number) => void
  quantityFixed?: boolean
}): React.ReactElement {
  const { maxQuantity, quantity, setQuantity, quantityFixed } = props
  const options = useMemo(
    () =>
      new Array(maxQuantity).fill(0).map((_v, i) => ({
        key: `${i}`,
        value: i + 1,
        text: `${i + 1}`,
      })),
    [maxQuantity],
  )
  return (
    <span>
      <select
        className="appearance-none outline-none pl-xs pr-eXxs bg-transparent"
        disabled={quantityFixed}
        onChange={e => {
          const value = e.currentTarget.value
          const q =
            typeof value === 'number'
              ? value
              : typeof value === 'string'
              ? parseInt(value, 10)
              : NaN
          if (!Number.isNaN(q)) {
            setQuantity(q)
          }
        }}
        value={quantity}>
        {options.map(o => (
          <option key={o.key} value={o.value}>
            {o.value}
          </option>
        ))}
      </select>
      {quantityFixed ? null : (
        <Icon name="downopenmini" className="pointer-events-none" />
      )}
    </span>
  )
}
